/*
 * Fix: keep the Kiwi size-chart trigger attached next to the "Select size"
 * legend even after a variant change.
 *
 * Root cause: Dawn's HTMLUpdateUtility.viewTransition() (assets/global.js)
 * does NOT update <variant-selects> in place. On every option change it
 * builds a brand-new <variant-selects> element, inserts it as a sibling
 * right before the old one, hides the old one, and removes the old one
 * ~500ms later. Anything moved inside the OLD element (like the Kiwi
 * size-chart block) is destroyed along with it, because it was never part
 * of the NEW element.
 *
 * Fix: watch the parent of <variant-selects> for a freshly inserted
 * <variant-selects> element, and move the live Kiwi wrapper node into that
 * new element's "Select size" legend immediately.
 */
document.addEventListener('DOMContentLoaded', function () {
  function findSizeLegend(variantSelects) {
    var fieldsets = variantSelects.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend.form__label');
      if (!legend) continue;
      var labelText = legend.textContent.trim().toLowerCase();
      if (labelText.indexOf('size') !== -1 || labelText.indexOf('maat') !== -1) {
        return legend;
      }
    }
    return null;
  }

  function attach(variantSelects, wrapper) {
    var legend = findSizeLegend(variantSelects);
    if (!legend) return false;
    if (legend.contains(wrapper)) return true;
    legend.appendChild(wrapper);
    legend.classList.add('variant-picker__legend--with-size-chart');
    return true;
  }

  document.querySelectorAll('variant-selects').forEach(function (initialVariantSelects) {
    // The wrapper the existing inline script created around the Kiwi block.
    // We keep moving this exact live node (never a clone) so any click
    // handlers Kiwi bound to it keep working.
    var wrapper = initialVariantSelects.querySelector('.kiwi-size-chart-inline');
    if (!wrapper) return;

    var parent = initialVariantSelects.parentNode;
    if (!parent) return;

    var observer = new MutationObserver(function (mutations) {
      for (var m = 0; m < mutations.length; m++) {
        var added = mutations[m].addedNodes;
        for (var i = 0; i < added.length; i++) {
          var node = added[i];
          if (node.nodeType === 1 && node.tagName === 'VARIANT-SELECTS') {
            attach(node, wrapper);
          }
        }
      }
    });
    observer.observe(parent, { childList: true });
  });
});
